import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61a7d49f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-h-[38px] tw-w-[38px] tw-justify-end" }
const _hoisted_2 = { class: "tw-max-w-full tw-overflow-x-auto tw-overflow-y-hidden placeholder" }
const _hoisted_3 = {
  key: 0,
  class: "tw-flex tw-justify-center tw-items-center tw-gap-[8px] tw-cursor-pointer"
}
const _hoisted_4 = {
  class: /*#__PURE__*/_normalizeClass(`tw-flex-1 tw-font-Poppins tw-text-[#231F20] tw-text-[11px] tw-not-italic tw-font-[400] tw-leading-[130%] title tw-line-clamp-2`)
}
const _hoisted_5 = {
  key: 1,
  class: "tw-flex tw-justify-center tw-items-center tw-gap-[8px] tw-cursor-pointer"
}
const _hoisted_6 = {
  class: /*#__PURE__*/_normalizeClass(`tw-flex-1 tw-font-Poppins tw-text-[#231F20] tw-text-[11px] tw-not-italic tw-font-[400] tw-leading-[130%] title tw-line-clamp-2`)
}
const _hoisted_7 = {
  class: "tw-font-[500]",
  "data-cy": "assessment-switcher-dropdown"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "7",
  viewBox: "0 0 10 7",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.104884 2.00642L4.67976 7.19266C4.72096 7.23621 4.77061 7.2709 4.82567 7.2946C4.88073 7.31831 4.94005 7.33054 5 7.33054C5.05995 7.33054 5.11927 7.31831 5.17433 7.2946C5.22939 7.2709 5.27904 7.23621 5.32024 7.19266L9.89512 2.00642C9.93169 1.96522 9.95972 1.91717 9.97757 1.86505C9.99541 1.81293 10.0027 1.75778 9.99909 1.70281C9.99458 1.6474 9.97901 1.59345 9.95329 1.54417C9.92758 1.49488 9.89224 1.45124 9.84937 1.41584L9.07996 0.771202C9.03793 0.734847 8.98904 0.707283 8.93618 0.690139C8.88332 0.672995 8.82756 0.666619 8.77219 0.671387C8.71709 0.675373 8.66333 0.690299 8.61406 0.715292C8.56479 0.740285 8.52099 0.774843 8.48522 0.816951L5.0707 4.74718C5.04968 4.76801 5.02128 4.77969 4.99168 4.77969C4.96209 4.77969 4.93369 4.76801 4.91266 4.74718L1.51478 0.816951C1.44755 0.736646 1.35249 0.684663 1.2486 0.671387C1.19352 0.666053 1.13793 0.671766 1.08508 0.688192C1.03223 0.704618 0.983193 0.731424 0.940838 0.767043L0.150633 1.41584C0.107763 1.45124 0.0724248 1.49487 0.0467083 1.54417C0.0209918 1.59345 0.0054186 1.6474 0.000909419 1.70281C-0.00273159 1.75778 0.00458484 1.81293 0.0224338 1.86505C0.0402828 1.91717 0.0683087 1.96522 0.104884 2.00642Z",
    fill: "#387DFF"
  })
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  id: "search",
  class: /*#__PURE__*/_normalizeClass(` tw-flex tw-items-center tw-gap-[13px] tw-self-stretch tw-px-[26px] tw-h-[42px] tw-py-[12px]`)
}
const _hoisted_11 = { class: "tw-flex tw-flex-row tw-items-center" }
const _hoisted_12 = ["value", "placeholder"]

import ProgressAnimation from "../../../assets/animation/progress_light.json";
import { LottieAnimation } from "lottie-web-vue";
import {
  computed,
  onBeforeMount,
  onBeforeUnmount,
  ref,
  watch,
  Ref,
  onMounted,
} from "vue";
import AssessmentSwitcherDropdownItem from "./assessmentSwitcherDropdownItem.vue";
import {
  getChecklistSelected,
  getComponentUiText,
  resultFilter,
} from "@/utils/utilities";
import { convertUTCTimeToLocalTime } from "@/utils/dateTimeUtils";
import store from "@/store";
import CloseBoxIcon from "@/components/svgs/closeBoxIcon.vue";
import AssessmentChecklistStatusTag from "@/components/assessment/assessmentChecklistStatusTag.vue";
import SearchIcon from "@/components/svgs/searchIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'assessmentSwitcherDropdown',
  props: {
  data: {
    type: Array,
    required: true,
  },
  dropdownClass: {
    type: String,
    required: false,
    default: "",
  },
  isTopLevelOnly: {
    type: Boolean,
    required: false,
    default: false,
  },
  isLoading: {
    type: Boolean,
    required: false,
    default: false,
  },
  isNoData: {
    type: Boolean,
    required: false,
    default: false,
  },
  isShowLandingPage: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["on-select-checklist"],
  setup(__props, { emit: emits }) {

const props = __props;




const showLandingText = ref(false);
const modelValue: Ref<string> = ref("");
const inputRef = ref<HTMLInputElement | null>(null);
const isOpen = ref(false);
const dataShown: any = ref(props.data);
const searchValue = ref("");

watch(
  () => props.data,
  () => {
    dataShown.value = props.data;
  },
);
watch(
  () => props.isNoData,
  () => {
    if (props.isNoData && props.isShowLandingPage) {
      showLandingText.value = false;
    }
  },
);
watch(
  () => props.isLoading,
  () => {
    if (props.isLoading && props.isShowLandingPage) {
      showLandingText.value = true;
      store.dispatch("Overlay/showOverlay", {
        isShowOverlay: true,
      });
    }
  },
);
onMounted(() => {
  if (props.isShowLandingPage) {
    store.dispatch("Overlay/showOverlay", {
      isShowOverlay: true,
    });
    showLandingText.value = true;
  }
});
const clearData = () => {
  handleSearch("");
  inputRef.value?.focus();
};
const handleSearch = (value: string) => {
  modelValue.value = value;
  searchValue.value = value;
  dataShown.value = resultFilter(value, props.data, props.isTopLevelOnly);
};

const currentChecklistReportId = computed(
  () =>
    store.getters["Recommend/getChecklistReportId"] ||
    store.getters["Sharing/getChecklistReportId"],
);

onBeforeMount(() => {
  window.addEventListener("click", () => {
    handleSearch("");
    isOpen.value = false;
  });
});

onBeforeUnmount(() => {
  window.removeEventListener("click", () => {
    isOpen.value = false;
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`tw-flex tw-flex-col tw-w-full ${
      isOpen.value ? 'opened' : ''
    } mainWrapper`),
    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
        () => {
          if (__props.isLoading) return;
          isOpen.value = !isOpen.value;
          if (!isOpen.value) {
            handleSearch('');
          }
        }
      )
    }, [
      _renderSlot(_ctx.$slots, "buttonDropdown", {}, () => [
        (__props.isLoading)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(`tw-w-full tw-flex tw-rounded-[6px] tw-bg-[#ffffff] tw-pl-[6px] ${
            showLandingText.value ? 'tw-z-[4]' : ''
          }`)
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_unref(LottieAnimation), {
                  ref: "anim",
                  "animation-data": _unref(ProgressAnimation),
                  "auto-play": true,
                  loop: true
                }, null, 8, ["animation-data"])
              ])
            ], 2))
          : _createCommentVNode("", true),
        (!__props.isLoading)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(`${
            showLandingText.value ? 'tw-z-[4]' : ''
          } tw-relative tw-min-h-[47px] tw-cursor-pointer tw-flex tw-justify-between tw-items-center tw-self-stretch tw-px-[20px] tw-py-[10px] tw-w-full tw-rounded-t-[6px] ${
            isOpen.value
              ? 'tw-bg-[#F6F7F8] header-shadow'
              : 'tw-bg-[#FFF] tw-rounded-b-[6px]'
          } dropdownButton`)
            }, [
              _createElementVNode("div", _hoisted_2, [
                (showLandingText.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(getComponentUiText)(
                    "app-component-assessment-switcher-landing-text-1",
                  )), 1)
                    ]))
                  : (
                _unref(getChecklistSelected)(
                  __props.data,
                  currentChecklistReportId.value,
                  __props.isTopLevelOnly,
                )
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("span", _hoisted_6, [
                          _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(getChecklistSelected)(
                      __props.data,
                      currentChecklistReportId.value,
                      __props.isTopLevelOnly,
                    )?.checklistName), 1),
                          _createTextVNode(_toDisplayString(` - ${_unref(convertUTCTimeToLocalTime)(
                    _unref(getChecklistSelected)(
                      __props.data,
                      currentChecklistReportId.value,
                      __props.isTopLevelOnly,
                    )?.checklistDate,
                  )}`), 1)
                        ]),
                        _createVNode(AssessmentChecklistStatusTag, {
                          "checklist-status": 
                  _unref(getChecklistSelected)(
                    __props.data,
                    currentChecklistReportId.value,
                    __props.isTopLevelOnly,
                  )?.checklistStatus
                ,
                          "checklist-status-id": 
                  _unref(getChecklistSelected)(
                    __props.data,
                    currentChecklistReportId.value,
                    __props.isTopLevelOnly,
                  )?.checklistStatusId
                ,
                          "is-loading": false,
                          "class-name": "tw-leading-[130%] tw-h-[24px] tw-px-[8px]"
                        }, null, 8, ["checklist-status", "checklist-status-id"])
                      ]))
                    : _createCommentVNode("", true)
              ]),
              _createElementVNode("span", {
                class: _normalizeClass(`tw-z-[1] arrowIcon ${
              isOpen.value ? 'rotated tw-pr-[10px]' : 'tw-pl-[10px]'
            }`)
              }, _hoisted_9, 2)
            ], 2))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(`dropdownBody tw-flex tw-flex-col tw-rounded-bl-[6px] tw-rounded-br-[6px] tw-bg-white tw-max-h-[260px] !tw-overflow-y-auto ${__props.dropdownClass}`)
    }, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(SearchIcon, {
            color: "#B7B7B7",
            class: _normalizeClass(`tw-w-[12px] tw-h-[12px] icon-pointer-unset`)
          })
        ]),
        _createElementVNode("input", {
          ref_key: "inputRef",
          ref: inputRef,
          value: modelValue.value,
          type: "text",
          class: "tw-border-none tw-w-full searchInput tw-h-[18px]",
          placeholder: 
            _unref(getComponentUiText)(
              'app-recommentdation-assessment-switcher-search-placeholder-1',
            )
          ,
          onInput: _cache[1] || (_cache[1] = (e) => handleSearch(e?.target?.value))
        }, null, 40, _hoisted_12),
        (modelValue.value !== '')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "tw-bg-transparent tw-border-none tw-outline-none",
              onClick: clearData
            }, [
              _createVNode(CloseBoxIcon, {
                size: 15,
                color: "#DBDBDB"
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataShown.value, (item, index) => {
        return (_openBlock(), _createBlock(AssessmentSwitcherDropdownItem, {
          key: index,
          "is-top-level-only": __props.isTopLevelOnly,
          index: index,
          item: item,
          level: 0,
          "is-modal-open": isOpen.value,
          "search-value": searchValue.value,
          "onUpdate:selected": 
          (checklist) => {
            if (showLandingText.value) {
              showLandingText.value = false;
              _unref(store).dispatch('Overlay/hideOverlay');
            }

            isOpen.value = false;
            if (!isOpen.value) {
              handleSearch('');
            }
            emits('on-select-checklist', checklist, index);
          }
        ,
          "onUpdate:childSelected": 
          (itemChildData) => {
            isOpen.value = false;
            if (!isOpen.value) {
              handleSearch('');
            }
            emits('on-select-checklist', itemChildData, index);
          }
        
        }, null, 8, ["is-top-level-only", "index", "item", "is-modal-open", "search-value", "onUpdate:selected", "onUpdate:childSelected"]))
      }), 128))
    ], 2)
  ], 2))
}
}

})